__turbopack_context__.v({
  "col3": "AddressForm-module__RK0UUa__col3",
  "inputRows": "AddressForm-module__RK0UUa__inputRows",
  "leftNoBorder": "AddressForm-module__RK0UUa__leftNoBorder",
  "noGap": "AddressForm-module__RK0UUa__noGap",
  "phoneCode": "AddressForm-module__RK0UUa__phoneCode",
  "root": "AddressForm-module__RK0UUa__root",
  "row": "AddressForm-module__RK0UUa__row",
});
